import { Component, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormType, StepDefinition } from '@lx/quote-tool/shared/types';
import { Observable, Subject, takeUntil } from 'rxjs';
import { getEnvironment } from '@lx/shared/tokens';
import { AcquisitionDisclaimerWidgetService, StepService } from '@lx/quote-tool/shared/services';
import { GoogleAnalyticsEvents } from '@lx/shared/google-analytics';

@Component({
  selector: 'lx-step-wrapper',
  templateUrl: './step-wrapper.component.html',
  styleUrls: ['./step-wrapper.component.scss'],
})
export class StepWrapperComponent implements OnInit, OnDestroy {
  @Input() stepDefinition: StepDefinition | undefined;
  @Input() disabledNextButton = false;

  @ViewChild('stepWrapper') stepWrapperRef: ElementRef<HTMLElement>;
  @ViewChild('acquisitionDisclaimerContainer', { static: true }) acquisitionDisclaimerContainer: ElementRef<HTMLElement> | undefined;

  formType: FormType | undefined = undefined;
  isJuniors: Observable<boolean> | undefined = undefined;

  isStepValid = false;
  isRtlEnabled = false;

  googleAnalyticsBackEvent = GoogleAnalyticsEvents.QUOTE_BACK;
  googleAnalyticsNextEvent = GoogleAnalyticsEvents.QUOTE_NEXT;

  private readonly destroy$ = new Subject<void>();

  private readonly environment = getEnvironment();
  private readonly stepService = inject(StepService);
  private readonly acquisitionDisclaimerWidgetService = inject(AcquisitionDisclaimerWidgetService);

  ngOnInit(): void {
    this.formType = this.stepService.getFormType();
    this.isJuniors = this.stepService.isJuniors$();
    this.isRtlEnabled = this.environment.RTL_ENABLED;

    this.stepService
      .getCurrentStepValid()
      .pipe(takeUntil(this.destroy$))
      .subscribe((validStep) => {
        this.isStepValid = validStep;
      });

    this.acquisitionDisclaimerWidgetService.loadWidget(this.acquisitionDisclaimerContainer);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  navigateToPreviousStep() {
    setTimeout(() => this.stepService.navigateToPreviousStep());
  }

  navigateToNextStep() {
    setTimeout(() => this.stepService.navigateToNextStep());
  }
}
